"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Share = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Share = function () { return (react_1.default.createElement("path", { fill: "currentColor", d: "M14.666 14.382c-6.292 0-12.664 2.666-13.33 6.118a.667.667 0 01-.654.547H.55a.613.613 0 01-.427-.173.667.667 0 01-.12-.44C.474 12.64 6.86 6.522 14.666 6.384v-3.44a.653.653 0 01.2-.48l.267-.267a.667.667 0 01.946 0l7.719 7.719a.64.64 0 010 .933l-7.719 7.719a.667.667 0 01-.946 0l-.267-.267a.653.653 0 01-.2-.48v-3.44z" })); };
exports.Share = Share;
//# sourceMappingURL=share.js.map